import type { Dispatch } from 'react';

import { wrapActionWithDispatch } from '../../utils';
import {
  goToSummary,
  setCurrentStep,
  setCustomerName,
  setCustomerSurname,
  setCustomerType,
  setExistingCustomer,
  setFrequency,
  setPackage,
  setTermsAndConditions,
  stepBack,
} from './actions';
import type { ActionType } from './types';

export function buildSetters(dispatch: Dispatch<ActionType>) {
  return {
    setCurrentStep: wrapActionWithDispatch(dispatch, setCurrentStep),
    setPackage: wrapActionWithDispatch(dispatch, setPackage),
    setCustomerType: wrapActionWithDispatch(dispatch, setCustomerType),
    setExistingCustomer: wrapActionWithDispatch(dispatch, setExistingCustomer),
    setCustomerName: wrapActionWithDispatch(dispatch, setCustomerName),
    setCustomerSurname: wrapActionWithDispatch(dispatch, setCustomerSurname),
    stepBack: wrapActionWithDispatch(dispatch, stepBack),
    setFrequency: wrapActionWithDispatch(dispatch, setFrequency),
    goToSummary: wrapActionWithDispatch(dispatch, goToSummary),
    setTermsAndConditions: wrapActionWithDispatch(dispatch, setTermsAndConditions),
  } as const;
}
